/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins'

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import SocketPlugin from './plugins/socket'
import { startVersionPoller } from './utils/versionPoller'
import './utils/authFetch'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(SocketPlugin)

registerPlugins(app)

app.mount('#app')

startVersionPoller()
